/* eslint-disable */
// @ts-nocheck
import React from "react";
import {
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@carbon/react";
import Button, { Icons } from "../buttons/Button";
import { ReactComponent as ModalCancelIcon } from "../../assets/icons/cancel.svg";
import { ReactComponent as ModalDeleteIcon } from "../../assets/icons/delete.svg";
import { EDIT_ROW_TRANSLATIONS } from "../../translations/util";

export enum DeleteModalIcons {
  Cancel,
  Delete,
}

const getModalIconFromName = (IconName: DeleteModalIcons) => {
  switch (IconName) {
    case DeleteModalIcons.Delete:
      return <ModalDeleteIcon />;
    case DeleteModalIcons.Cancel:
      return <ModalCancelIcon />;
    default:
      return null;
  }
};

interface IProps {
  modalHeaderText: string;
  modalDescriptionText: string;
  cancelButtonLabel?: string;
  confirmationButtonLabel?: string;
  cancelIcon?: DeleteModalIcons;
  onDelete?: () => void;
  open: boolean;
  setOpen: (active: boolean) => void;
  preventCloseOnClickOutside?: boolean;
}

const DeleteModal = ({
  modalHeaderText,
  modalDescriptionText,
  confirmationButtonLabel,
  cancelButtonLabel,
  cancelIcon,
  onDelete,
  open,
  setOpen,
  preventCloseOnClickOutside = true,
}: IProps) => {
  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      if (open) {
        setOpen(false);
      }
    }
  };

  return (
    <ComposedModal
      className="modal-content"
      size="sm"
      open={open}
      setOpen={setOpen}
      onKeyDown={handleKeyPress}
      preventCloseOnClickOutside={preventCloseOnClickOutside}
      selectorPrimaryFocus={".w-full"}
    >
      <ModalHeader
        buttonOnClick={() => {
          setOpen(false);
        }}
        data-cy={`${modalHeaderText.split(" ").join("")}-modalHeader`}
      >
        <h4 className="flex">
          <span className="modal-icon" data-cy="modalIcon">
            {getModalIconFromName(cancelIcon) ||
              getModalIconFromName(DeleteModalIcons.Delete)}
          </span>
          {modalHeaderText}
        </h4>
      </ModalHeader>

      <ModalBody hasForm>
        <p
          className="bx--modal-content__text bx--modal-content__regular-content"
          data-cy={`${modalHeaderText.split(" ").join("")}-modalDescription`}
        >
          {modalDescriptionText}
        </p>
      </ModalBody>

      <ModalFooter>
        <Button
          kind="tertiary"
          className="w-full"
          label={
            cancelButtonLabel ||
            EDIT_ROW_TRANSLATIONS.DELETE_MODAL.buttonLabels.keepIt
          }
          onClick={() => {
            setOpen(false);
          }}
          dataCy={`${modalHeaderText.split(" ").join("")}-keepIt-`}
        />

        <Button
          kind="danger"
          className="w-full"
          label={
            confirmationButtonLabel ||
            EDIT_ROW_TRANSLATIONS.DELETE_MODAL.buttonLabels.delete
          }
          icon={Icons.Delete}
          onClick={onDelete}
          dataCy={
            confirmationButtonLabel
              ? `${modalHeaderText.split(" ").join("")}-goBack-`
              : `${modalHeaderText.split(" ").join("")}-yesDelete-`
          }
        />
      </ModalFooter>
    </ComposedModal>
  );
};
export default DeleteModal;
